<template>
  <div class="not-found">
    Page 404 Not Found
  </div>
</template>
<script>
export default {
  name: 'notfound'
}
</script>
<style>
.not-found {
  padding: 1em;
  font-size: 2em;
}
</style>
